import { Image as ImageIcon, Loader2 } from 'lucide-react'

type Props = {
  onPick: () => void
  accepted: string
  pending: boolean
}

/**
 * Empty-state dropzone galerii - duża strefa zachęcająca do dodania pierwszego
 * zdjęcia. Po dodaniu choćby jednego pliku gallery przełącza się w grid mode.
 */
export function GalleryEmptyDropzone({ onPick, accepted, pending }: Props) {
  return (
    <button
      type="button"
      onClick={onPick}
      disabled={pending}
      className="rounded-md border-2 border-dashed border-slate-300 bg-white hover:bg-slate-50 px-4 py-6 flex flex-col items-center justify-center gap-1.5 text-sm text-slate-500 transition-colors disabled:opacity-60"
    >
      {pending ? (
        <>
          <Loader2 size={20} className="animate-spin text-sky-600" />
          <span>Wgrywanie...</span>
        </>
      ) : (
        <>
          <ImageIcon size={20} className="text-slate-400" />
          <span><span className="font-medium text-slate-700">Kliknij aby dodać zdjęcia</span> (możesz wybrać wiele)</span>
          <span className="text-xs text-slate-400">Dozwolone: {accepted}</span>
        </>
      )}
    </button>
  )
}
